import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=65b53304&scoped=true&"
import script from "./purchased.vue?vue&type=script&lang=js&"
export * from "./purchased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b53304",
  null
  
)

export default component.exports